export default "__VITE_ASSET__D4_vo_Pr__"